var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageRoot"},[_c('head-com',{staticClass:"head-com",attrs:{"headObj":_vm.headObj}}),_c('tree-table-com',_vm._b({},'tree-table-com',_vm.tableConfig,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }